module.exports = __webpack_public_path__ + "static/media/settings.bb6373ea.svg";